import React from "react";
import { useHistory } from "react-router-dom";
import { Card, Row, Col, Button, Spin } from "antd";
import { RollbackOutlined, BarsOutlined } from "@ant-design/icons";
import SweepRuleAddForm from "../Forms/SweepRuleAddForm";
import useSweepAccess from "../../util/useSweepAccess";

const SweepRuleFormPage = (props) => {
  const history = useHistory();
  const { loading: accessLoading, hasAccess } = useSweepAccess();
  const editId = props.match.params.id;

  const goToList = () => history.push("/tos-sweep-rule");

  if (accessLoading || !hasAccess) {
    return (
      <div style={{ textAlign: "center", padding: 48 }}>
        <Spin />
      </div>
    );
  }

  return (
    <div>
      <Row style={{ marginBottom: 12 }}>
        <Col span={18}>
          <p style={{ fontSize: "120%", marginTop: -9 }}>
            <BarsOutlined />{" "}
            {editId ? "SÜPÜRME KURALI GÜNCELLE" : "SÜPÜRME KURALI EKLE"}
          </p>
        </Col>
        <Col span={6} style={{ textAlign: "right" }}>
          <Button onClick={goToList}>
            <RollbackOutlined /> Geri
          </Button>
        </Col>
      </Row>

      <Card>
        <SweepRuleAddForm editId={editId} onSuccess={goToList} />
      </Card>
    </div>
  );
};

export default SweepRuleFormPage;
